module.exports = __webpack_public_path__ + "media/public/img/lightning-icon-ad999d6c2741dc7d9703ebf5fe6a1169.png";